export const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const debounce = (func, wait) => {
  const debounceTimeout = {};

  return function executedFunction(...args) {
    // fixed debounce when several components using debounce were rendered in the same view
    // however unexpected behaviour will happen when one component would need one than more
    // debounce instances to run independently
    // todo: fix explained above
    // eslint-disable-next-line no-underscore-dangle
    const id = this._uid;

    const later = () => {
      clearTimeout(debounceTimeout[id]);
      return func.bind(this)(...args);
    };

    clearTimeout(debounceTimeout[id]);
    debounceTimeout[id] = setTimeout(later, wait);
  };
};
